<template>
	<div>
		<talent-info :row="row"></talent-info>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import talentInfo from '../../../components/talentInfo';
export default {
	components: {
		talentInfo,
	},
	mixins: [mixin],
};
</script>
